import {
  ResponseTimeTypeActionTypes,
  RESPONSE_TIME_TYPE_FAIL,
  RESPONSE_TIME_TYPE_LOADING,
  RESPONSE_TIME_TYPE_SUCCESS,
  ResponseTimeTypeState,
  RESPONSE_TIME_TYPE_API_MSG,
  RESPONSE_TIME_TYPE_API_RES,
} from "./ActionTypes";
import { ResponseTimeTypeResponse } from "./Model";

const initialStateGetPosts: ResponseTimeTypeState = {
  loading: false,
  responseTimeTypeRes: {} as ResponseTimeTypeResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getResponseTimeTypeListReducer = (
  state = initialStateGetPosts,
  action: ResponseTimeTypeActionTypes
): ResponseTimeTypeState => {
  switch (action.type) {
    case RESPONSE_TIME_TYPE_LOADING:
      return {
        ...state,
        loading: true,
        responseTimeTypeRes: {} as ResponseTimeTypeResponse,
      };
    case RESPONSE_TIME_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        responseTimeTypeRes: action.payload,
        successMsg: action.successMsg,
        status: action.status,
      };
    case RESPONSE_TIME_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        responseTimeTypeRes: {} as ResponseTimeTypeResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case RESPONSE_TIME_TYPE_API_MSG:
      return {
        ...state,
        loading: false,
        responseTimeTypeRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case RESPONSE_TIME_TYPE_API_RES:
      return {
        ...state,
        loading: false,
        responseTimeTypeRes: {} as ResponseTimeTypeResponse,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
